module.exports = __webpack_public_path__ + "static/media/candle.b09efccb.JPG";